export const farmDataInputs = {
  location: { state: 'State', county: 'County' },
  FSA: 'Farm Number',
  regulatoryPermit: 'Permit ID',
  Notes: 'Notes'
};

export default farmDataInputs;
